import { createSelector } from '@ngrx/store';
import { Seq } from 'immutable';
import { SystemTimestampType } from 'src/graphql/generated/graphql.generated';
import {
  selectAllTimestamps,
  selectAllTimestampTypes,
} from 'src/store/entityStores/entity-store-selectors';
import { TimestampRecord } from 'src/store/generated/timestamp-record.generated';

export function selectTimestampById(id: string) {
  return createSelector(selectAllTimestamps, (timestamps) => {
    return timestamps.get(id);
  });
}

export function selectTimestampsByCardId(cardId: string) {
  return createSelector(selectAllTimestamps, (timestamps) => {
    return cardId == null
      ? Seq.Indexed<TimestampRecord>()
      : timestamps
          .filter((ts) => ts.cardId === cardId)
          .toIndexedSeq()
          .sortBy((ts) => ts.time);
  });
}

export function selectTimestampsByTypeAndCardId(cardId: string, timestampTypeId: string) {
  return createSelector(
    selectTimestampsByCardId(cardId),
    selectAllTimestampTypes,
    (timestamps, timestampTypes) => {
      return timestamps.find((ts) => ts.typeId === timestampTypeId);
    },
  );
}

export function selectTimestampByCardIdAndType(
  cardId: string,
  systemTimestampType: SystemTimestampType,
) {
  return createSelector(
    selectTimestampsByCardId(cardId),
    selectAllTimestampTypes,
    (timestamps, timestampTypes) => {
      const type = timestampTypes.find((ts) => ts.systemTimestampType === systemTimestampType);
      return type == null ? undefined : timestamps.find((ts) => ts.typeId === type.id);
    },
  );
}
